export default "__VITE_ASSET__CP0wvOCx__"